/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'ICON_protect': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<path pid="0" d="M16 31.5C6.063 25.765.509 15.357.5 4.656c9.937-5.736 21.725-5.343 31 0 0 9.64-4.404 18.254-11.31 23.938C19 25 16.436 21.937 14.5 20c-1.938-1.938-6-4-6-7.5 0-2.5 1.97-3.998 4.11-3.998 1.458 0 2.729.807 3.39 1.998a3.874 3.874 0 0 1 3.39-1.998c2.14 0 4.11 1.498 4.11 3.998s-2.5 5-5.5 5"/>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/ICON_protect.js